import { Tabs } from "flowbite-react";
import { useState } from "react";
import { useApplication } from "../contexts/ApplicationContext";
import {
  MdControlPointDuplicate,
  MdMonitorHeart,
  MdSupportAgent,
} from "react-icons/md";
import { FaMagnifyingGlass, FaTable } from "react-icons/fa6";
import AdminQueriesTable from "../components/tables/AdminQueriesTable";
import AdminTablesTable from "../components/tables/AdminTablesTable";
import AdminUsersTable from "../components/tables/AdminUsersTable";
import AdminProvidersTable from "../components/tables/AdminProvidersTable";
import AdminHelpCenterTable from "../components/tables/AdminHelpCenterTable";
import { IoMdPeople, IoMdPricetags } from "react-icons/io";
import { LiaSellsy } from "react-icons/lia";
import AdminRedudancyTable from "../components/tables/AdminRedudancyTable";
import SystemVariablesManagerPage from "./SystemVariablesManagerPage";
import { GiSettingsKnobs } from "react-icons/gi";
import VPSMonitorPage from "./VPSMonitorPage";
import RepresentativeTablePage from "./RepresentativeTablePage";
import SerasaSettingsPage from "./SerasaSettingsPage";

const AdminPage = () => {
  const { user, userPermission } = useApplication();
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "Tabelas",
      icon: FaTable,
      content: <AdminTablesTable isActive={activeTab === 0} />,
    },
    {
      title: "Usuários",
      icon: IoMdPeople,
      content: <AdminUsersTable isActive={activeTab === 1} />,
    },
    {
      title: "Configuráveis",
      icon: GiSettingsKnobs,
      content: <SystemVariablesManagerPage isActive={true} />,
    },
    {
      title: "Configuração Serasa",
      icon: GiSettingsKnobs,
      content: <SerasaSettingsPage />,
    },
  ];

  if (userPermission === "POWER_USER") {
    tabs.push(
      {
        title: "Consultas",
        icon: FaMagnifyingGlass,
        content: <AdminQueriesTable isActive={true} />,
      },
      {
        title: "Provedores",
        icon: LiaSellsy,
        content: <AdminProvidersTable isActive={true} />,
      },
      {
        title: "Suporte",
        icon: MdSupportAgent,
        content: <AdminHelpCenterTable isActive={true} />,
      },
      {
        title: "Redundância",
        icon: MdControlPointDuplicate,
        content: <AdminRedudancyTable isActive={true} />,
      },
      {
        title: "Monitoramento",
        icon: MdMonitorHeart,
        content: <VPSMonitorPage isActive={true} />,
      }
    );
  }

  return (
    <div className="bg-white px-4 py-4 rounded-md shadow-md relative">
      <Tabs
        aria-label="Admin Tabs"
        id="tab-company-details"
        activeTab={activeTab}
        onActiveTabChange={(tabIndex) => setActiveTab(tabIndex)}
      >
        {tabs.map((tab, index) => (
          <Tabs.Item key={index} title={tab.title} icon={tab.icon}>
            {/* Apenas ativa o conteúdo da tab atual */}
            {index === activeTab && tab.content}
          </Tabs.Item>
        ))}
      </Tabs>
    </div>
  );
};

export default AdminPage;
